(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const closeMenuBtn = document.querySelector('.close.js-nav-control');

    if (closeMenuBtn && window.innerWidth > 1199) {
      closeMenuBtn.setAttribute('aria-hidden', 'true');
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    
$(document).ready(function () {

    let hasHash = false;
    var urlHash = location.hash;
    if (urlHash != ''){hasHash = true;}
    var activeMobileItem;
    var activeDesktopItem;


  // SET ACTIVE ITEM IF URL HASH EXISTS:
    if (hasHash === true){
      //console.log("HASH =" + urlHash);
      activeMobileItem = $('#mobile-faq-menu').find('a[href="' + urlHash +'"]');
      activeDesktopItem = $('#desktop-faq-menu').find('a[href="' + urlHash +'"]');
      setActive(activeMobileItem,activeDesktopItem);
      // wait a sec for scrolltrigger to init then go to section
      setTimeout(function() {
        scrollToTarget(urlHash);
      }, 500);
    } else {
      $('#mobile-faq-menu .js_selected-item').html('Choose Topic');
    }

  // RESPONSIVE SCROLL TO TARGET
    function scrollToTarget(target){
      if ($(window).width() > 767) {
        $('html, body').animate({scrollTop: $(target).offset().top }, 500);
      } else {
        // offset position for mobile because of pinned nav
        $('html, body').animate({scrollTop: $(target).offset().top - 112 }, 500); // 112 = .js_selected-item height + 36)
      }
    }

  // ACTIVE ITEM SWITCHING FUNCTION:
    function setActive(mobileItem,desktopItem){
      // adjust mobile menu:
      var mobileItemText = mobileItem.html();
      var mobileTarget = mobileItem.attr('href');
      //console.log("mobileItemText = " + mobileItemText);
      $('#mobile-faq-menu .js_selected-item').html(mobileItemText);
      mobileItem.addClass('active-item');
      $('#mobile-faq-menu a').not(mobileItem).each(function(){
          $(this).removeClass('active-item');
       });

      // adjust desktop menu:
      desktopItem.addClass('active-item');
      $('#desktop-faq-menu a').not(desktopItem).each(function(){
        $(this).removeClass('active-item');
      });
      // handles desktop submenus
      if(desktopItem.parents('.js_submenu').length > 0) {
        desktopItem.closest('.js_has-submenu').addClass('expanded').find('.js_submenu').slideDown(200, function() {
           if ( $('.js_faq-desktop--pinto .pin-spacer').length > 0 ){
             // scrolltrigger is init'd, so refresh it
             ScrollTrigger.refresh();
           }
        });
       } else  {
       //  console.log("this is a link without a submenu, safely close up the submenus");
         $('#desktop-faq-menu .js_has-submenu').removeClass('expanded').find('.js_submenu').slideUp(200, function() {
           if ( $('.js_faq-desktop--pinto .pin-spacer').length > 0 ){
             // scrolltrigger is init'd, so refresh it
             ScrollTrigger.refresh();
           }
         });
       }
    }

  // MOBILE NAVIGATION
    $('#mobile-faq-menu').removeClass('open');
    $('#mobile-faq-menu').click(function() {
      $( this ).toggleClass('open');
    });
    $('#mobile-faq-menu a').click(function(e) {
      var target = $(this).attr('href');
      scrollToTarget(target);
      $('html, body').animate({scrollTop: $($.attr(this, 'href')).offset().top - 112 }, 500); // 112 = .js_selected-item height + 36)
      activeMobileItem = $(this);
      activeDesktopItem = $('#desktop-faq-menu').find('a[href="' + target +'"]');
      setActive(activeMobileItem,activeDesktopItem);
    });


  // DESKTOP NAVIGATION
  // links manipulation
    $('#desktop-faq-menu a').click(function(){
      activeDesktopItem = $(this);
      var target = $(this).attr('href');
      scrollToTarget(target);
      activeMobileItem = $('#mobile-faq-menu').find('a[href="' + target +'"]');
      setActive(activeMobileItem,activeDesktopItem);
    });
  // submenu toggles
    $('#desktop-faq-menu .js_submenu-trigger').click(function(){
       $('#desktop-faq-menu .js_submenu-trigger').not(this).each(function(){
          $(this).next('.js_submenu').slideUp(200, function() {
            ScrollTrigger.refresh(true);
          });
          $(this).closest('.js_has-submenu').removeClass('expanded');
       });
       $(this).next('.js_submenu').slideToggle(200, function() {
         ScrollTrigger.refresh(true);
       });
       $(this).closest('.js_has-submenu').toggleClass('expanded');
    });

});

  } catch(e) { console.error(e); }
})();
})();
